import axios from "axios";

class ApiService {
  static async request(method, url, data = {}, config = {}) {
    try {
        //console.log("ApiService.request: method, url,data,config →",method, url,data,config);

      const response = await axios({ method, url, data, ...config });
      console.log("ApiService.request: ",response)
      return response;
    } catch (error) {
      if (error.response) {
        // El 401 de sesión vencida lo atiende utils/sesionVencida (interceptor global).
        console.error(`Error ${error.response.status}:`, error.response.data);
      } else {
        console.error("Error de red o desconocido:", error);
      }
      return Promise.reject(error); // Sirve para menejar errores donde se instancie(solo si es necesario)
    }
  }

  static get(url, config = {}) {
    return this.request("get", url, {}, config);
  }

  static post(url, data, config = {}) {
    return this.request("post", url, data, config);
  }

  static put(url, data, config = {}) {
    return this.request("put", url, data, config);
  }

  static delete(url, config = {}) {
    return this.request("delete", url, {}, config);
  }
}


/*
const fetchStatus = async () => {
  return ApiService.get('/career-status');
};

const createUser = async (userData) => {
  return ApiService.post('/users', userData);
};

const updateUser = async (id, userData) => {
  return ApiService.put(`/users/${id}`, userData);
};

const deleteUser = async (id) => {
  return ApiService.delete(`/users/${id}`);
};

*/

export default ApiService;
